import {HiArrowDown} from "react-icons/hi2";
import { HiArrowUpRight } from "react-icons/hi2";
import {motion} from "framer-motion";
import React from "react";

export default function EndHomepage(){
    return(
        <div>
            <motion.div
                variants={{
                    hidden: { opacity: 0, y: -50 },
                    visible: { opacity: 1, y: 0 }
                }}
                initial="hidden"
                whileInView="visible"
                transition={{duration: 0.6, delay: 0.4}}
                viewport={{once: false}}
            >
                <HiArrowDown className="text-6xl mx-auto"  />
            </motion.div>

            <motion.div
                className="flex my-16"
                variants={{
                    hidden: { opacity: 0, y: -50 },
                    visible: { opacity: 1, y: 0 }
                }}
                initial="hidden"
                whileInView="visible"
                transition={{duration: 0.6, delay: 0.8}}
                viewport={{once: false}}
            >
                <div className="mx-auto bg-gradient-to-r from-blue-400 to-pink-400 hover:bg-gradient-to-r hover:from-pink-400 hover:to-blue-400 rounded-full text-2xl text-white py-4 px-6 flex items-center justify-center">
                    <div>Learn More About BioGlimmer&nbsp;</div>
                    <HiArrowUpRight className="text-3xl" />
                </div>
            </motion.div>

            <div className="hs-accordion-group max-w-3xl px-4 mx-auto mb-16">
                <div className="hs-accordion border rounded-lg py-4 px-8" id="hs-basic-with-title-and-arrow-stretched-heading-one">
                    <button className="hs-accordion-toggle hs-accordion-active:text-blue-500 text-xl py-4 inline-flex items-center justify-between gap-x-3 w-full font-semibold text-start text-gray-800 hover:text-gray-500 rounded-lg disabled:opacity-50 disabled:pointer-events-none" aria-expanded="false" aria-controls="hs-basic-with-title-and-arrow-stretched-collapse-one">
                        Reference of licensed images
                        <svg className="hs-accordion-active:hidden block size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m6 9 6 6 6-6"></path>
                        </svg>
                        <svg className="hs-accordion-active:block hidden size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m18 15-6-6-6 6"></path>
                        </svg>
                    </button>
                    <div id="hs-basic-with-title-and-arrow-stretched-collapse-one" className="hs-accordion-content hidden text-lg text-gray-800 w-full overflow-hidden transition-[height] duration-300" role="region" aria-labelledby="hs-basic-with-title-and-arrow-stretched-heading-one">
                        <ul className="marker:text-blue-500 list-disc pl-5 space-y-4 mb-4">
                            <li>
                                Reference 1 content Reference 1 content Reference 1 content Reference 1 content Reference 1 content Reference 1 content Reference 1 content Reference 1 content Reference 1 content Reference 1 content Reference 1 content Reference 1 content Reference 1 content
                            </li>
                            <li>
                                Reference 2 content Reference 2 content Reference 2 content Reference 2 content Reference 2 content Reference 2 content Reference 2 content Reference 2 content Reference 2 content Reference 2 content Reference 2 content Reference 2 content Reference 2 content
                            </li>
                            <li>
                                Reference 3 content Reference 3 content Reference 3 content Reference 3 content Reference 3 content Reference 3 content Reference 3 content Reference 3 content Reference 3 content Reference 3 content Reference 3 content Reference 3 content Reference 3 content
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}